<div class="row mx-auto pl-lg-5 pt-lg-5">
    <div class="col-md-4">
        <div class="container send-money" >
            <h3 class="sm-6 purpose-heding"> Payment Method</h3>
            
            
            <div  class="md-6 sm-12 mt-2" >
                <form >
                    <div class="form-group">
                        
                        <select  (change)="onChange($event)" class="form-control border-0 box-shadows" name="payment_method">
                            <option value=""> --Select Payment Method-- </option>
                            <option value="bank"> Bank </option>
                            <option value="card"> Card </option>
                        </select>
                        
                    </div>
                    
                    <button (click)="onAddBank()" *ngIf="selectedType == 'bank'" type="button" class="btn btn-primary btn-lg mb-2">Add Bank</button>
                    
                    <button (click)="onAddCard()" *ngIf="selectedType == 'card'" type="button" class="btn btn-primary btn-lg mb-2">Add Card</button>
                    
                </form>
            </div>
           
        </div>
        <div class="p-0" [ngClass]="{'d-none': !bankShown}" id="widget-root-type"></div>
    </div>
</div>
